import React, { useEffect, useState } from 'react';

/**
 * Full-viewport overlay when the viewport is mobile-width and landscape.
 * Rendered at the app root so it covers navbar, sidebar, and all page content.
 */
const MobileLandscapeBlocker: React.FC = () => {
  const [active, setActive] = useState(() => {
    if (typeof window === 'undefined') return false;
    return (
      window.matchMedia('(max-width: 767px)').matches &&
      window.matchMedia('(orientation: landscape)').matches
    );
  });

  useEffect(() => {
    const mobileMq = window.matchMedia('(max-width: 767px)');
    const orientationMq = window.matchMedia('(orientation: landscape)');
    const apply = () => setActive(mobileMq.matches && orientationMq.matches);
    apply();
    mobileMq.addEventListener('change', apply);
    orientationMq.addEventListener('change', apply);
    return () => {
      mobileMq.removeEventListener('change', apply);
      orientationMq.removeEventListener('change', apply);
    };
  }, []);

  useEffect(() => {
    if (!active) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [active]);

  if (!active) return null;

  return (
    <div
      className="fixed inset-0 z-[500000] flex min-h-[100dvh] min-h-screen w-full flex-col items-center justify-center bg-[#F8F7F2] px-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="mobile-landscape-blocker-title"
      aria-describedby="mobile-landscape-blocker-desc"
    >
      <div className="text-center max-w-sm w-full rounded-lg border border-gray-200 bg-white p-8 shadow-sm">
        <p
          id="mobile-landscape-blocker-title"
          className="text-lg font-semibold text-gray-900"
        >
          Landscape mode is not supported
        </p>
        <p
          id="mobile-landscape-blocker-desc"
          className="mt-2 text-sm text-gray-600"
        >
          Please switch to portrait view to continue.
        </p>
      </div>
    </div>
  );
};

export default MobileLandscapeBlocker;
